/** The form a "View form" click opened beside the workflow. */
export interface IAffiliateBuilderFormTab {
  formId: string;
  label: string;
}

/** Tab identity for the affiliate workflow builder screen. Its layout is the shared
 * `WorkflowBuilderAgentLayout`, whose constants live in `WorkflowBuilderLayoutHelper`. */
export class AffiliateWorkflowBuilderHelper {
  /** The workflow tab is always open, so its id is fixed. A form tab is identified by its form id. */
  static readonly WORKFLOW_TAB_ID = 'workflow';

  static getTabId(tabValue: string): string {
    return `affiliate-builder-tab-${tabValue}`;
  }

  static getTabPanelId(tabValue: string): string {
    return `affiliate-builder-panel-${tabValue}`;
  }
}
